var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "-3.911 0 100 100",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#6D6E71",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M91.053,85.774 c0,5.779-4.743,10.466-10.594,10.466H13.713c-5.851,0-10.595-4.687-10.595-10.466V13.559c0-5.781,4.744-10.466,10.595-10.466h66.746 c5.851,0,10.594,4.685,10.594,10.466V85.774z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M91.053,85.774 c0,5.778-4.743,10.466-10.594,10.466H13.713c-5.851,0-10.595-4.688-10.595-10.466V13.559c0-5.781,4.744-10.466,10.595-10.466h66.746 c5.851,0,10.594,4.685,10.594,10.466V85.774z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E71",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M80.459,98.333H13.713 C6.704,98.333,1,92.699,1,85.774V13.559C1,6.634,6.704,1,13.713,1h66.746c7.011,0,12.713,5.634,12.713,12.559v72.215 C93.172,92.699,87.47,98.333,80.459,98.333z M13.713,5.186c-4.673,0-8.475,3.756-8.475,8.373v72.215 c0,4.616,3.802,8.372,8.475,8.372h66.746c4.673,0,8.476-3.756,8.476-8.372V13.559c0-4.617-3.803-8.373-8.476-8.373H13.713z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.8fc24cdd8c23d53f8dba5eaf15f6a420.svg";
export { ForwardRef as ReactComponent };